import type { Executions } from 'features/executions'

import Celebrate from 'assets/image/icons/emotions/celebrate.png'
import Funny from 'assets/image/icons/emotions/funny.png'
import Insightful from 'assets/image/icons/emotions/insightful.png'
import Like from 'assets/image/icons/emotions/like.png'
import Love from 'assets/image/icons/emotions/love.png'
import Support from 'assets/image/icons/emotions/support.png'

import { FormField } from '../formField'

const imageMap = {
	Celebrate,
	Funny,
	Insightful,
	Like,
	Love,
	Support
}

export function ReactionSelect({
	currentEmotion,
	emotions,
	onChoose
}: {
	currentEmotion?: Executions.PostReaction
	emotions: Executions.PostReaction[]
	onChoose: (emotion: Executions.PostReaction) => void
}) {
	return (
		<FormField beforeLabel={'React on last post'} label='Select a reaction'>
			<ul className='field-list'>
				{emotions.map((item, index) => {
					return (
						<li
							className={
								currentEmotion === item
									? 'field-text-emotion-active'
									: 'field-text-emotion'
							}
							key={index}
							onClick={() => onChoose(item)}
						>
							<img
								alt={item}
								className='action-emotion'
								height='30px'
								src={imageMap[item]}
							/>
							<p
								className={
									currentEmotion === item
										? 'text-emotion-active'
										: 'text-emotion'
								}
							>
								{item}
							</p>
						</li>
					)
				})}
			</ul>
		</FormField>
	)
}
